<template>
    <div>
        <div class="ts-flex justify-content-between">
            <div class="justify-content-start">
                <ts-button outline color="info" @click.prevent="addNew">{{ $t('add_new') }}</ts-button>
                <div class="ts-flex-grow"></div>
            </div>
            <div class="justify-content-end mr-2">
                <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" />
            </div>
        </div>
        <div class="mt-3">
            <Table :columns="columns" :data="resources" :loading="loading" max-height="700" stripe highlight-row
                size="small" ref="selection">
                <template slot-scope="{ row }" slot="total">
                    $ {{  calculateTotalAmount(row.details) }}
                </template>
                <template slot-scope="{ row }" slot="action">
                    <a href="#" v-tooltip="$t('edit')" class="mr-2 text-primary" @click.prevent="onClickEdit(row)">
                        <i class="fas fa-edit"></i>
                    </a>
                    <a-popconfirm placement="topLeft" :ok-text="$t('yes')" :cancel-text="$t('no')"
                        @confirm="clickDelete(row)">
                        <template slot="title">
                            <p>
                                {{ $t('are_you_sure_to_delete') }}
                            </p>
                        </template>
                        <a class="mr-2 text-danger" href="#" v-tooltip="$t('delete')" :disabled="row._deleting">
                            <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                            <i class="fas fa-trash" v-else></i>
                        </a>
                    </a-popconfirm>
                </template>
            </Table>

            <a-modal v-if="showForm" v-model="showForm" :title="$t('feePredefineItem.pageTitle')" centered
                :maskClosable="false" :zIndex="1020" :footer="null" width="80%" @ok="closeForm" @cancel="closeForm">
                <form-action :edit-data="editData" @close="closeForm" />
            </a-modal>
        </div>
        <div class="d-flex justify-content-between align-items-center p-15">
            <ts-total-list v-model="pagination" />
            <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
    </div>
</template>

<script>
import FormAction from './form'
import { mapActions, mapState } from 'vuex'
import expandRow from './table-expand.vue'
import { debounce } from 'lodash'

export default {
    name: 'preDefine',
    components: { FormAction },
    data() {
        return {
            loading: false,
            showForm: false,
            editData: undefined,
            deleting: false
        }
    },
    computed: {
        ...mapState('feePredefineItem', ['resources', 'pagination']),
        columns() {
            return [
                {
                    type: 'expand',
                    render: (h, params) => {
                        return h(expandRow, {
                            props: {
                                records: params.row.details
                            }
                        })
                    },
                    width: 30
                },
                { title: this.$t('feePredefineItem.grade'), key: 'grade_name_foreign' },
                { title: this.$t('feePredefineItem.level'), key: 'level_name_foreign' },
                { title: this.$t('feePredefineItem.mainProgram'), key: 'acp_name_foreign' },
                { title: this.$t('feePredefineItem.subProgram'), key: 'acps_name_foreign' },
                { title: this.$t('feePredefineItem.remak'), key: 'remark' },
                { title: this.$t('feePredefineItem.totalAmount'), slot: 'total' },
                {
                    title: this.$t('actions'),
                    slot: 'action',
                    fixed: 'right',
                    align: 'center',
                    width: 100
                }
            ]
        },
        search: {
            get() {
                return this.$store.state.feePredefineItem.search
            },
            set(newValue) {
                this.$store.commit('feePredefineItem/SET_SEARCH', newValue)
                this.$store.commit('feePredefineItem/RESET_CURRENT_PAGE')
            }
        },
    },
    created() {
        this.fetchData()
    },
    methods: {
        ...mapActions('feePredefineItem', ['onDelete']),
        addNew() {
            this.editData = undefined
            this.showForm = true
        },
        closeForm() {
            this.showForm = false
            this.editData = undefined
            this.fetchData()
        },
        fetchData(attribute = {}) {
            this.loading = true
            this.$store
                .dispatch('feePredefineItem/fetch', { branch_id: this.branch_id, ...attribute })
                .then(() => { this.loading = false })
                .catch(err => { this.loading = false; this.$toasted.error(err.message) })
        },
        onClickEdit(row) {
            this.editData = row
            this.showForm = true
        },
        clickDelete(record) {
            record._deleting = true
            this.onDelete(record.id)
                .then((response) => {
                    this.$toasted.success(response.data.message)
                    this.fetchData()
                })
                .catch((errror) => {
                    this.errors = new Errors(errror.response.data.errors)
                })
                .finally(() => record._deleting = false)
        },
        calculateTotalAmount(details) {
			return details.reduce((total, item) => {
				return total + Number(item.total_amount)
			}, 0)
		
        }
    },
    watch: {
        search: debounce(function () {
            this.fetchData()
        }, 500),
    }
}
</script>